module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-global-bg-1-sp-4eeaadf7420234aa6c5c1a8aa9730e23.png";